module.exports = __webpack_public_path__ + "fonts/capture-it.bf99f8d8.ttf";